module.exports = __webpack_public_path__ + "media/images/excursion-5f814b56e5e74c55229dd6fe4c06d9a7.svg";